import { GameInformationServiceEvent, IServices } from "@netent/origin";
import { IPlayUIState } from "@netent/playui";
import { ListenerCreator } from "../../types";

const changed = (services: IServices) => (): IPlayUIState => ({
  gameInformation: services.gameInformation.getGameInformation()
});

export const listeners = new Map<GameInformationServiceEvent, ListenerCreator>([
  ["changed", changed]
]);
